import {
    List
} from '../Components'

export default [
    {path: '/letter-dashboard', component: List, name: 'letter-dashboard'},
]